import { lazy } from 'react'
import { createFileRoute } from '@tanstack/react-router'

// Lazy load the Settings Profile feature
const SettingsProfile = lazy(() => import('@/features/settings/profile'))

export const Route = createFileRoute('/_authenticated/settings/')({
  component: SettingsProfile,
})
